import { render, staticRenderFns } from "./AnaliseMunicipios.vue?vue&type=template&id=4d62e0ba&"
import script from "./AnaliseMunicipios.vue?vue&type=script&lang=js&"
export * from "./AnaliseMunicipios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports